
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { api_url, initSocket, socket } from '../../utils/utils'
import api from '../../api/api'

// Mövcud login/register actions...
export const admin_login = createAsyncThunk(
    'auth/admin_login',
    async (info, {rejectWithValue, fulfillWithValue}) => {
        try {
            const {data} = await api.post(`/admin-login`, info, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue({
                ...(error.response?.data || { error: 'Giriş zamanı xəta baş verdi. Zəhmət olmasa yenidən cəhd edin.' }),
                status: error.response?.status
            })
        }
    }
);

export const seller_register = createAsyncThunk(
    'auth/seller_register',
    async (info, {rejectWithValue, fulfillWithValue}) => {
        try {
            const {data} = await api.post(`/seller-register`, info, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Qeydiyyat zamanı xəta baş verdi', status: error.response?.status })
        }
    }
);

export const verify_seller_registration = createAsyncThunk(
    'auth/verify_seller_registration',
    async (info, {rejectWithValue, fulfillWithValue}) => {
        try {
            const {data} = await api.post(`/verify-seller-registration`, info, {withCredentials: true})
            // localStorage.setItem('accessToken', data.token)
            // initSocket(data.token) 
            initSocket()   // ← connect socket with JWT immediately
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Satıcı qeydiyyatı təsdiqlənmədi', status: error.response?.status })
        }
    }
);

export const resend_seller_verification = createAsyncThunk(
    'auth/resend_seller_verification',
    async (info, {rejectWithValue, fulfillWithValue}) => {
        try {
            const {data} = await api.post(`/resend-seller-verification`, info, {withCredentials: true})
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Kod göndərilə bilmədi', status: error.response?.status })
        }
    }
);

export const seller_login = createAsyncThunk(
    'auth/seller_login',
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(`/seller-login`, info, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue({
                ...(error.response?.data || { error: 'Giriş zamanı xəta baş verdi. Zəhmət olmasa yenidən cəhd edin.' }),
                status: error.response?.status
            })
        }
    }
);

export const seller_login_otp_verify = createAsyncThunk(
    'auth/seller_login_otp_verify',
    async ({ challengeId, code }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/seller/login-otp/verify', { challengeId, code })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue({ ...(error.response?.data || { code: 'LOGIN_OTP_FAILED', error: 'Kod yoxlana bilmədi.' }), status: error.response?.status })
        }
    }
)

export const seller_login_otp_resend = createAsyncThunk(
    'auth/seller_login_otp_resend',
    async ({ challengeId }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/seller/login-otp/resend', { challengeId })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue({ ...(error.response?.data || { code: 'LOGIN_OTP_FAILED', error: 'Kod göndərilə bilmədi.' }), status: error.response?.status })
        }
    }
)

// 🆕 PASSWORD RESET ACTIONS
export const forgot_seller_password = createAsyncThunk(
    'auth/forgot_seller_password',
    async ({ email }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(`/forgot-seller-password`, { email });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Email göndərilə bilmədi', status: error.response?.status });
        }
    }
);

export const verify_seller_reset_code = createAsyncThunk(
    'auth/verify_seller_reset_code',
    async ({ email, code }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(`/verify-seller-reset-code`, { email, code });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Kod yoxlana bilmədi', status: error.response?.status });
        }
    }
);

export const reset_seller_password = createAsyncThunk(
    'auth/reset_seller_password',
    async ({ email, code, newPassword }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(`/reset-seller-password`, { email, code, newPassword });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Şifrə dəyişdirilə bilmədi', status: error.response?.status });
        }
    }
);

// Digər actions...
// export const profile_image_upload = createAsyncThunk(
//     'auth/profile_image_upload',
//     async (image, { rejectWithValue, fulfillWithValue,getState }) => {
//         const token = getState().auth.token || localStorage.getItem('accessToken');
//         const config= {
//             headers: {
//                 Authorization : `Bearer ${token}`
//             }
//         }
//         try {
//             const { data } = await api.post(`/profile-image-upload`, image, config)
//             return fulfillWithValue(data)
//         } catch (error) {
//             return rejectWithValue(error.response.data)
//         }
//     }
// );
export const profile_image_upload = createAsyncThunk(
    'auth/profile_image_upload',
    async (image, { rejectWithValue, fulfillWithValue }) => {
        try {
            // ❌ getState().auth.token + Authorization header — SİL
            const { data } = await api.post(`/profile-image-upload`, 
                image, 
                { withCredentials: true }   // ✅ cookie kifayətdir
            )
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Şəkil yüklənə bilmədi', status: error.response?.status })
        }
    }
);

// export const profile_info_add = createAsyncThunk(
//     'auth/profile_info_add',
//     async (info, { rejectWithValue, fulfillWithValue, getState }) => {
//         const token = getState().auth.token || localStorage.getItem('accessToken');
//         const config = {
//             headers: {
//                 Authorization: `Bearer ${token}`
//             },
            
//         }
//         try {
//             const { data } = await api.post(`/profile-info-add`, info, config)
//             return fulfillWithValue(data)
//         } catch (error) {
//             return rejectWithValue(error.response.data)
//         }
//     }
// );
export const profile_info_add = createAsyncThunk(
    'auth/profile_info_add',
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            // ❌ getState().auth.token + Authorization header — SİL
            const { data } = await api.post(`/profile-info-add`, 
                info, 
                { withCredentials: true }   // ✅
            )
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Məlumat əlavə edilmədi', status: error.response?.status })
        }
    }
);

// export const get_user_info = createAsyncThunk(
//     'auth/get_user_info',
//     async (_, { rejectWithValue, fulfillWithValue, getState }) => {
//         const token = getState().auth.token || localStorage.getItem('accessToken'); 
//         const config = {
//             headers: {
//                 'Authorization': `Bearer ${token}`
//             },
            
//         }
//         try {
//             const { data } = await axios.get(`${api_url}/api/get-user`, config)
//             return fulfillWithValue(data)
//         } catch (error) {
//             return rejectWithValue(error.response.data)
//         }
//     }
// );
export const get_user_info = createAsyncThunk(
    'auth/get_user_info',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            // ❌ token + Authorization header — SİL
            // ✅ withCredentials — cookie avtomatik göndərilir
            const { data } = await api.get('/get-user')
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Session check failed' })
        }
    }
);


export const get_seller_balance = createAsyncThunk(
    'auth/get_seller_balance',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await axios.get(`${api_url}/api/seller-balance`, { withCredentials: true });
            console.log('✅ Balance data:', data)
            return fulfillWithValue(data);
            
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Balans əldə edilmədi' });
        }
    }
);

// export const logout = createAsyncThunk(
//     'auth/logout',
//     async ({ navigate, role }, { rejectWithValue }) => {
//         try {
//             // localStorage.removeItem('accessToken')
//             if (role === 'admin') {
//                 navigate('/admin/login')
//             } else {
//                 navigate('/login')
//             }
//         } catch (error) {
//             return rejectWithValue(error.response.data)
//         }
//     }
// )
export const logout = createAsyncThunk(
    'auth/logout',
    async ({ navigate, role }, { fulfillWithValue }) => {
        if (socket.connected) socket.disconnect()
        socket.auth = {}
        try {
            await api.post('/logout')
        } catch (error) {
            console.log('Logout cleanup continued after API error:', error.response?.status || error.message)
        } finally {
            // ✅ Phase 3.1 — staff də admin login səhifəsinə qayıdır
            if (role === 'admin' || role === 'staff') {
                navigate('/admin/login', { replace: true })
            } else {
                navigate('/login', { replace: true })
            }
        }
        return fulfillWithValue()
    }
)
// On page refresh, reconnect the socket if a valid token is already stored
// const _storedToken = localStorage.getItem('accessToken')
// if (_storedToken && returnRole(_storedToken)) {
//     initSocket(_storedToken)
// }

export const authReducer = createSlice({
    name: 'auth',
    initialState: {
        successMessage: '',
        errorMessage: '',
        loader: false,
        userInfo: '',
        // role: returnRole(localStorage.getItem('accessToken')),
        // token: localStorage.getItem('accessToken'),
        role:'',
        token: '',
        balance: 0,
        transactions: [],
        isBanned: false,
        banReason: '',
        isLocked: false,
        lockTime: 0,
        authChecked: false
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = ""
            state.successMessage = ""
        },
        privilegedSessionExpired: (state) => {
            state.role = ''
            state.userInfo = ''
            state.token = ''
            state.balance = 0
            state.transactions = []
            state.authChecked = true
        },
        adminIdentityUpdated: (state, { payload }) => {
            if (!state.userInfo || state.userInfo.role !== 'admin') return
            state.userInfo = { ...state.userInfo, name: payload.name, email: payload.email,
                image: payload.image || payload.profileImage || '', status: payload.status, mfaEnabled: payload.mfaEnabled }
        }
    },
    extraReducers: (builder) => {
        builder
           .addCase(admin_login.pending, (state) => {
            state.loader = true
            state.errorMessage = ''
        })
        .addCase(admin_login.rejected, (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        })
        .addCase(admin_login.fulfilled, (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
            state.errorMessage = ''
            state.role = ''
            state.userInfo = ''
        })

        .addCase(seller_register.pending, (state) => {
            state.loader = true
        })
        .addCase(seller_register.rejected, (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        })
        .addCase(seller_register.fulfilled, (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
        })

        .addCase(verify_seller_registration.pending, (state) => {
            state.loader = true
        })
        .addCase(verify_seller_registration.rejected, (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        })
        .addCase(verify_seller_registration.fulfilled, (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
            state.role = 'seller'
        })

        .addCase(resend_seller_verification.pending, (state) => {
            state.loader = true
        })
        .addCase(resend_seller_verification.rejected, (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload.error
        })
        .addCase(resend_seller_verification.fulfilled, (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
        })

        .addCase(seller_login.pending, (state) => {
            state.loader = true
            state.errorMessage = ''
        })
        .addCase(seller_login.rejected, (state, { payload }) => {
            state.loader = false
            
            if (payload?.isBanned) {
                state.errorMessage = 'Hesabınız bloklanıb'
                state.isBanned = true
                state.banReason = payload.reason || 'Səbəb göstərilməyib'
            } 
            else if (payload?.isLocked) {
                state.errorMessage = payload.error
                state.isLocked = true
                state.lockTime = payload.lockTime || 0
            } 
            else {
                state.errorMessage = payload?.error || payload?.message || "Naməlum xəta"
            }
        })
        .addCase(seller_login.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        // Password success is pre-authentication; seller authority begins only
        // after the OTP verification response establishes the cookie session.
        state.role = ''
        state.userInfo = ''
        state.isBanned = false
        state.banReason = ''
        state.isLocked = false
        state.lockTime = 0
        })
        .addCase(seller_login_otp_verify.pending, (state) => { state.loader = true; state.errorMessage = '' })
        .addCase(seller_login_otp_verify.rejected, (state, { payload }) => { state.loader = false; state.errorMessage = payload?.error || 'Kod yoxlana bilmədi.' })
        .addCase(seller_login_otp_verify.fulfilled, (state, { payload }) => {
            state.loader = false; state.successMessage = payload.message; state.role = 'seller'; state.userInfo = payload.userInfo || ''
        })
        .addCase(seller_login_otp_resend.pending, (state) => { state.loader = true; state.errorMessage = '' })
        .addCase(seller_login_otp_resend.rejected, (state, { payload }) => { state.loader = false; state.errorMessage = payload?.error || 'Kod göndərilə bilmədi.' })
        .addCase(seller_login_otp_resend.fulfilled, (state, { payload }) => { state.loader = false; state.successMessage = payload.message })

        .addCase(forgot_seller_password.pending, (state) => {
            state.loader = true
        })
        .addCase(forgot_seller_password.rejected, (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload?.error || 'Email göndərilə bilmədi'
        })
        .addCase(forgot_seller_password.fulfilled, (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
        })

        .addCase(verify_seller_reset_code.pending, (state) => {
            state.loader = true
        })
        .addCase(verify_seller_reset_code.rejected, (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload?.error || 'Kod yoxlana bilmədi'
        })
        .addCase(verify_seller_reset_code.fulfilled, (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
        })

        .addCase(reset_seller_password.pending, (state) => {
            state.loader = true
        })
        .addCase(reset_seller_password.rejected, (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload?.error || 'Şifrə dəyişdirilə bilmədi'
        })
        .addCase(reset_seller_password.fulfilled, (state, { payload }) => {
            state.loader = false
            state.successMessage = payload.message
        })

        .addCase(get_user_info.fulfilled, (state, { payload }) => {
            state.loader = false
            state.userInfo = payload?.userInfo || ''
            state.role = payload?.userInfo?.role || ''
            state.authChecked = true
            if (payload?.userInfo) initSocket()
        })
        .addCase(get_user_info.rejected, (state) => {
            state.loader = false
            state.userInfo = ''
            state.role = ''
            state.token = ''
            state.balance = 0
            state.transactions = []
            state.authChecked = true
        })

        .addCase(profile_image_upload.pending, (state) => {
            state.loader = true
        })
        .addCase(profile_image_upload.rejected, (state, { payload }) => {
            state.loader = false
            state.errorMessage = payload?.error || 'Şəkil yüklənə bilmədi'
        })
        .addCase(profile_image_upload.fulfilled, (state, { payload }) => {
            state.loader = false
            state.userInfo = payload.userInfo
            state.successMessage = payload.message
        })

        .addCase(profile_info_add.pending, (state) => {
            state.loader = true
        })
        .addCase(profile_info_add.rejected, (state, { payload }) => {
            console.log('❌ Balance rejected:', payload) 
            state.loader = false
            state.errorMessage = payload?.error || 'Məlumat əlavə edilmədi'
        })
        .addCase(profile_info_add.fulfilled, (state, { payload }) => {
            state.loader = false
            state.userInfo = payload.userInfo
            state.successMessage = payload.message
        })
        
        .addCase(get_seller_balance.fulfilled, (state, { payload }) => {
            state.balance = payload.balance
            state.transactions = payload.transactions
        })
        .addCase(logout.fulfilled, (state) => {
            state.role = ''
            state.userInfo = ''
            state.token = ''
            state.balance = 0
            state.transactions = []
            state.authChecked = true
        })
    }
});

export const { messageClear, privilegedSessionExpired, adminIdentityUpdated } = authReducer.actions;
export default authReducer.reducer;
